import React, { createContext, useContext, useMemo } from "react";
import { useAuth } from "./AuthContext";

import { SupabaseUserInfo, UserRole } from "@/types/supabase";

interface SidebarContextType {
  userRole: UserRole | null;
  isDriver: boolean;
  supabaseInfo: SupabaseUserInfo | null;
  userNickname: string | null;
}

export const SidebarContext = createContext<SidebarContextType | undefined>(
  undefined,
);

export function SidebarProvider({ children }: { children: React.ReactNode }) {
  const { userRole, isDriver, supabaseInfo, userNickname } = useAuth();

  // Solo re-render si cambian los datos esenciales del sidebar
  const value = useMemo(
    () => ({
      userRole,
      isDriver,
      supabaseInfo,
      userNickname,
    }),
    [userRole, isDriver, supabaseInfo, userNickname],
  );

  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
}

export function useSidebar() {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
}
